<div class="description-section-skewed"></div>
<div class="block-container" [ngStyle]="{'background-image': backgroundUrl ? 'url(' + backgroundUrl + ')' : '' }">
    <div class="container">
        <div class="row clearfix">
            <div class="col-md-12">
                <div class="block-skewed-fix">
                    <div class="content-block countdown-next-draw">
                        <div class="countdown-next-draw-headline text-center pt-lg-3">
                            <h2>Vær med i næste trækning</h2>
                        </div>
                        <div class="row">
                            <div class="countdown-next-draw-counter">
                                <app-countdown-sale-stop [showAllCountdownBlocks]="true" [counterHeading]="true">
                                </app-countdown-sale-stop>
                            </div>
                        </div>
                        <button (click)="showPage()" class="cta cta--primary mx-auto">KØB DINE LODDER HER</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>